import React from 'react';
import { Paper, Typography } from '@mui/material';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import PeopleIcon from '@mui/icons-material/People';
import { useTranslation } from 'react-i18next';
import StatCard from '../StatCard';
import StatCardsRow from '../StatCardsRow';
import EarningsBarChartYearly from '../Charts/EarningsBarChartYearly';
import { statPaper, statTitle } from '../../../styles/CalculateMoney/OverviewCommonStyles';

function normalizeYearlyArr(data, yearsBack, currentYear) {
  let arr = [];
  if (!data) arr = [];
  else if (Array.isArray(data)) arr = data;
  else if (Array.isArray(data.$values)) arr = data.$values;

  const map = {};
  arr.forEach(y => {
    if (y && y.year) map[y.year] = y;
  });

  return Array.from({ length: yearsBack }, (_, i) => {
    const year = currentYear - i;
    return map[year] || { year, totalEarnings: 0, sessionCount: 0 };
  }).reverse();
}

export default function OverviewYearView({ data, yearsBack = 5, currentYear = new Date().getFullYear() }) {
  const { t } = useTranslation('overview');

  const yearlyArr = normalizeYearlyArr(data, yearsBack, currentYear);

  const totalEarnings = yearlyArr.reduce((sum, y) => sum + (y.totalEarnings || 0), 0);
  const totalSessions = yearlyArr.reduce((sum, y) => sum + (y.sessionCount || 0), 0);

  const years =
    yearlyArr.length > 0
      ? `${yearlyArr[0].year} – ${yearlyArr[yearlyArr.length - 1].year}`
      : '';

  return (
    <>
      <StatCardsRow>
        <StatCard
          icon={<MonetizationOnIcon fontSize="large" />}
          label={t('stats.totalEarnings')}
          value={`${totalEarnings} €`}
          color="primary"
        />
        <StatCard
          icon={<PeopleIcon fontSize="large" />}
          label={t('stats.totalSessions')}
          value={totalSessions}
          color="success"
        />
      </StatCardsRow>
      <Paper elevation={0} sx={statPaper}>
        <Typography variant="subtitle1" sx={statTitle}>
          {t('year.overviewForYears', { years })}
        </Typography>
        <EarningsBarChartYearly yearlyDetails={yearlyArr} />
      </Paper>
    </>
  );
}